module.exports = __webpack_public_path__ + "static/img/banner-robot.fd9c441.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/banner-robot.png
// module id = FWRM
// module chunks = 1